import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import TokensNavUI from '../../../components/superUser/loan/util/TokensNavUI'
import SystemGeneratedPropertyListSF from '../../../components/superUser/loan/util/SystemGeneratedPropertyListSF'
import './TokenListPage.css'

const TokenSListPageUI = ({
  context,
  errorList,
  loan,
  systemGeneratedPropertyList,
  selectedDocType,
  docTypeOptionList,
  onDocTypeChange,
  onRefreshClick,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_tl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !systemGeneratedPropertyList} loan={loan} page='tokenS'
    dimension='w768'
  >
    {
      (!loan || !errorList || !systemGeneratedPropertyList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && systemGeneratedPropertyList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Information</b></span>
            </span>
          }
          right={
            <span className='g_select_container'>
              <SelectSingleSF
                optionList={docTypeOptionList}
                selectedKey={selectedDocType || 'all'}
                onChange={onDocTypeChange}
                placeholder='Document type'
              />
            </span>
          }
        />

        <TokensNavUI context={context} loan={loan} page='tokenS' />

        <SystemGeneratedPropertyListSF context={context} loan={loan} propertyList={systemGeneratedPropertyList}
          category='general_s' categoryLabel='System generated tokens'
        />

      </div>
    }
  </SuperUserLoanPageUI>

export default TokenSListPageUI
